import useEditorText from './useEditorText';

export const useEditorCharactersCount = () => {
  const text = useEditorText();

  return text.length;
};
